<template>
  <div class="px-4 py-3 bg-primary/5 border-t border-border space-y-2">
    <!-- Item Count -->
    <div class="flex items-center justify-between text-sm text-muted-foreground">
      <span>Items:</span>
      <span class="font-semibold text-foreground">{{ cartStore.itemCount }}</span>
    </div>

    <!-- Total Quantity -->
    <div class="flex items-center justify-between text-sm text-muted-foreground">
      <span>Quantity:</span>
      <span class="font-semibold text-foreground">{{ cartStore.totalItems }}</span>
    </div>

    <!-- Subtotal -->
    <div class="flex items-center justify-between pt-2 border-t border-border">
      <span class="font-semibold text-foreground">Subtotal:</span>
      <span class="font-bold text-primary text-lg">
        {{ formatCurrency(cartStore.subtotal) }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCartStore } from '@/stores/cartStore';

const cartStore = useCartStore();

const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};
</script>
